import {
  ActionButton,
  Card,
  Icon,
  Image,
  InputCheckbox,
  InputCode,
  InputField,
  InputFieldV2,
  Skeleton,
  Text,
} from "../custom-components";
import React from "react";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/adminLogin.css";
import {
  generateloginOtp,
  getLoginUserProfile,
  getUserProfile,
  verifyLoginOtp,
} from "../store/actions/CommonAction";
import { useDispatch, useSelector } from "react-redux";
import "../styles/toast.css";
import { Slide, ToastContainer, toast } from "react-toastify";
import CustomToast from "./CustomToastContainer";
import { disableSandboxMode } from "../utils/sandboxMode";
import config from "../utils/config";
import { makeAPICall } from "../utils/ApiCall";
import { 
  BsShieldFillCheck, BsGearFill, BsBarChartFill, BsPeopleFill, BsShieldLockFill, 
  BsBuildingFill, BsEnvelopeFill, BsKeyFill, BsArrowRight 
} from "react-icons/bs";// UUID generator function (same as in CommonAction.js)
const uuidv4 = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const AdminLogin = () => {
  const privuLogo = new URL("../assets/privu-logo.png", import.meta.url).href;

  // Clear sandbox mode when user accesses login page
  useEffect(() => {
    disableSandboxMode();
    console.log('🚪 Entering login page - Sandbox mode cleared');
    
    // Prevent back navigation after logout
    window.history.pushState(null, '', window.location.href);
    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
    };
    window.addEventListener('popstate', handlePopState);
    
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const [emailMobile, setEmailMobile] = useState("");
  const [values, setValues] = useState(null);
  const [panNo, setPanNo] = useState("");
  const [isPanValid, setIsPanValid] = useState(null);
  const [emailMobileValid, setEmailMobileValid] = useState(null);
  const [isOtpValid, setIsOtpValid] = useState(false);
  const [initialPan, setInitialPan] = useState(true);
  const [initTxnId, setInitTxnId] = useState("");
  const [initalOtp, setInitialOtp] = useState(true);
  const [otp, setOtp] = useState("");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [totp, setTotp] = useState("");
  const [showTotpModal, setShowTotpModal] = useState(false);
  const [isTotpValid, setIsTotpValid] = useState(false);
  const [initialTotp, setInitialTotp] = useState(true);
  const [retryCountMsg, setRetryCountMsg] = useState("");
  const dispatch = useDispatch();
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const mobileRegex = /^[6-9]\d{9}$/;
  const clientIdRegex = /^CLT(?:[0-9]{2})(?:0[1-9]|1[0-2])[A-Z0-9]{4}[A-F0-9]$/;
  const [idType, setIdType] = useState(""); // "PAN" or "CLIENT_ID"

  const emailMob = useSelector((state) => state.common.login_email_mobile);
  const panNumber = useSelector((state) => state.common.login_pan_no);
  const navigate = useNavigate();
  const [counter, setCounter] = useState(60);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [disableAllFields, setDisableAllFields] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [isVerifyingTotp, setIsVerifyingTotp] = useState(false);

  // Refs for input fields
  const panInputRef = useRef(null);
  const emailMobileInputRef = useRef(null);
  const otpInputRef = useRef(null);
  const totpInputRef = useRef(null);

  // Tab navigation now works natively - no need for custom handling
  // useEffect(() => {
  //   if (showOtpModal || showTotpModal) return;

  //   const panInput = panInputRef.current?.querySelector('input');

  //   const handlePanTab = (e) => {
  //     if (e.key === 'Tab' && !e.shiftKey) {
  //       e.preventDefault();
  //       setTimeout(() => {
  //         const emailInput = emailMobileInputRef.current?.querySelector('input');
  //         if (emailInput) {
  //           emailInput.focus();
  //         }
  //       }, 0);
  //     }
  //   };

  //   if (panInput) {
  //     panInput.addEventListener('keydown', handlePanTab);
  //     return () => {
  //       panInput.removeEventListener('keydown', handlePanTab);
  //     };
  //   }
  // }, [showOtpModal, showTotpModal]);

  // Tab navigation now works natively for OTP modal
  // useEffect(() => {
  //   if (!showOtpModal) return;

  //   const handleOtpTab = (e) => {
  //     if (e.key === 'Tab' && !e.shiftKey) {
  //       e.preventDefault();
  //       setTimeout(() => {
  //         const verifyButton = document.querySelector('.otp-button button');
  //         if (verifyButton) {
  //           verifyButton.focus();
  //         }
  //       }, 0);
  //     }
  //   };

  //   const otpInput = otpInputRef.current?.querySelector('input');
  //   if (otpInput) {
  //     otpInput.addEventListener('keydown', handleOtpTab);
  //     return () => {
  //       otpInput.removeEventListener('keydown', handleOtpTab);
  //     };
  //   }
  // }, [showOtpModal]);

  // Tab navigation now works natively for TOTP modal
  // useEffect(() => {
  //   if (!showTotpModal) return;

  //   const handleTotpTab = (e) => {
  //     if (e.key === 'Tab' && !e.shiftKey) {
  //       e.preventDefault();
  //       setTimeout(() => {
  //         const verifyButton = document.querySelector('.otp-button button');
  //         if (verifyButton) {
  //           verifyButton.focus();
  //         }
  //       }, 0);
  //     }
  //   };

  //   const totpInput = totpInputRef.current?.querySelector('input');
  //   if (totpInput) {
  //     totpInput.addEventListener('keydown', handleTotpTab);
  //     return () => {
  //       totpInput.removeEventListener('keydown', handleTotpTab);
  //     };
  //   }
  // }, [showTotpModal]);

  // const handlePanChange = (e) => {
  //   const value = e.target.value.toUpperCase();

  //   setPanNo(value);

  //   if (panRegex.test(value)) {
  //     setIsPanValid(true);
  //   } else {
  //     setIsPanValid(false);
  //   }
  // };

  const handlePanChange = (e) => {
    const value = e.target.value.toUpperCase();
    setPanNo(value);

    if (panRegex.test(value) || clientIdRegex.test(value)) {
      setIsPanValid(true);
    } else {
      setIsPanValid(false);
    }
  };




  const handleOtpChange = (e) => {
    const value = e.target.value;

    setOtp(value);

    if (value && value.length === 6) {
      setIsOtpValid(true);
    } else {
      setIsOtpValid(false);
    }
  };

  const handleEmailMobileChange = (e) => {
    const value = e.target.value;
    setEmailMobile(value);

    if (emailRegex.test(value)) {
      setEmailMobileValid(true);
      // setEmailMobile(value.toUpperCase());
      setValues(1); // email
    } else if (mobileRegex.test(value)) {
      setEmailMobileValid(true);
      setValues(0); // mobile
    } else {
      setEmailMobileValid(false);
      setValues(null);
    }
  };

  const startTimer = () => {
    setIsResendDisabled(true); // Disable "Resend OTP" while counting down
    const timer = setInterval(() => {
      setCounter((prevCounter) => {
        if (prevCounter === 0) {
          clearInterval(timer);
          setIsResendDisabled(false); // Enable button when timer completes
          return 60;
        }
        return prevCounter - 1; // decrement normally
      });
    }, 1000);
  };
  const handleOtpSubmit = async () => {
    if (otp.length !== 6) {
      toast.error(
        (props) => (
          <CustomToast
            {...props}
            type="error"
            message={"Invalid OTP. Please try again."}
          />
        ),
        { icon: false }
      );
      return;
    }

    if (otp === "" || otp === null || otp === undefined) {
      toast.error(
        (props) => (
          <CustomToast {...props} type="error" message={"Please enter OTP."} />
        ),
        { icon: false }
      );
      return;
    }

    setIsVerifyingOtp(true);
    try {
      let res = await dispatch(
        verifyLoginOtp(panNo, otp, emailMobile, values, initTxnId, null)
      );
      if (res.status == 200) {
        const tenantId = res?.data?.tenantId || "";
        const userId = res?.data?.userId || "";
        const sessionToken = res?.data?.xsessionToken || "";
        const businessId = tenantId;
        try {
          await logAuditEvent(tenantId, businessId, userId, sessionToken, panNo);
        } catch (error) {
          console.error('Failed to log audit event:', error);
        }
        disableSandboxMode();
        toast.success(
          (props) => (
            <CustomToast {...props} type="success" message={"OTP Verified Successfully."} />
          ),
          { icon: false }
        );
        setDisableAllFields(true);
        setTimeout(() => { navigate("/dpo-dashboard"); }, 2000);
      }
      setIsVerifyingOtp(false);
    } catch (error) {
      setIsVerifyingOtp(false);
      toast.error(
        (props) => (
          <CustomToast {...props} type="error" message={error.message} />
        ),
        { icon: false }
      );
    }
  };

  // Function to log audit event on login
  const logAuditEvent = async (tenantId, businessId, userId, sessionToken, panNo) => {
    if (!tenantId || !businessId) {
      console.warn('Missing tenantId or businessId for audit log');
      return;
    }

    try {
      const txnId = uuidv4();
      const transactionId = uuidv4();
      
      // Get client IP address (using placeholder as per user's request to keep values static)
      const ipAddress = "192.168.1.1";

      const headers = {
        txn: txnId,
        "X-Tenant-ID": tenantId,
        "X-Business-ID": businessId,
        "X-Transaction-ID": transactionId,
        "Content-Type": "application/json",
      };

      // Build initiator string with PAN
      const initiator = "Data Fiduciary";

      const body = {
        actor: {
          id: "PAN No./Client ID", // Use userId if available, otherwise default
          role: "Legal-Admin",
          type: "USER"
        },
        businessId: businessId,
        group: "Consent",
        component: "Privu Consent Management System",
        actionType: "LOGIN",
        resource: {
          type: "userId",
          id: userId || txnId // Use userId if available, otherwise default
        },
        initiator: initiator,
        context: {
          txnId: transactionId,
          ipAddress: ipAddress
        },
        extra: {
          legalEntityName: "XYZ Pvt Ltd",
          pan: panNo || ""
        }
      };

      const response = await makeAPICall(
        config.get_audit_reports,
        "POST",
        body,
        headers
      );

      console.log('✅ Audit log created successfully:', response);
      return response;
    } catch (error) {
      console.error('❌ Error creating audit log:', error);
      throw error;
    }
  };

  const handleTotpSubmit = async () => {
    if (totp.length !== 6) {
      setInitialTotp(false);
      toast.error(
        (props) => (
          <CustomToast
            {...props}
            type="error"
            message={"Please enter a valid 6-digit TOTP."}
          />
        ),
        { icon: false }
      );
      setIsTotpValid(false);
      return;
    }

    if (totp === "" || totp === null || totp === undefined) {
      setInitialTotp(false);
      toast.error(
        (props) => (
          <CustomToast {...props} type="error" message={"Please enter TOTP."} />
        ),
        { icon: false }
      );
      setIsTotpValid(false);
      return;
    }

    setIsVerifyingTotp(true);
    try {
      let res = await dispatch(
        verifyLoginOtp(panNo, otp, emailMobile, values, initTxnId, totp)
      );

      if (res.status == 200) {
        setIsTotpValid(true);
        
        // Get data from response for audit log
        const tenantId = res?.data?.tenantId || "";
        const userId = res?.data?.userId || "";
        const sessionToken = res?.data?.xsessionToken || "";
        // For login, businessId is same as tenantId
        const businessId = tenantId;
        
        // Call audit API after successful login
        try {
          await logAuditEvent(tenantId, businessId, userId, sessionToken, panNo);
        } catch (error) {
          console.error('Failed to log audit event:', error);
          // Continue with login even if audit fails
        }
        
        // Clear sandbox mode on successful login
        disableSandboxMode();
        console.log('✅ Login successful - Sandbox mode cleared');
        
        toast.success(
          (props) => (
            <CustomToast
              {...props}
              type="success"
              message={"OTP Verified Successfully."}
            />
          ),
          { icon: false }
        );
        setDisableAllFields(true);
        setTimeout(() => {
          navigate("/dpo-dashboard");
        }, 2000);
      }
      setIsVerifyingTotp(false);
    } catch (error) {
      setIsVerifyingTotp(false);
      setInitialTotp(false);
      toast.error(
        (props) => (
          <CustomToast {...props} type="error" message={error.message} />
        ),
        { icon: false }
      );
      return;
    }
  };

  const handleResend = async (e) => {
    e.preventDefault();

    try {
      const res = await dispatch(generateloginOtp(panNo, values, emailMobile));
      if (res.status === 200 || res.status == 201) {
        toast.success(
          (props) => (
            <CustomToast
              {...props}
              type="success"
              message={"OTP Sent successfully."}
            />
          ),
          { icon: false }
        );
        setOtp("");
        setInitTxnId(res.data.txnId);
        startTimer();
      }
    } catch (err) {
      const error = err?.response?.data || err;

      toast.error(
        (props) => (
          <CustomToast {...props} type="error" message={error[0].errorMsg} />
        ),
        { icon: false }
      );
      return;
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // alert("handleSubmit");
      const res = await dispatch(generateloginOtp(panNo, values, emailMobile));

      if (res.status === 200 || res.status == 201) {
        toast.success(
          (props) => (
            <CustomToast
              {...props}
              type="success"
              message={"OTP Sent successfully."}
            />
          ),
          { icon: false }
        );
        setInitTxnId(res.data.txnId);
        setShowOtpModal(true);
        setCounter(60);
        setIsResendDisabled(true);
        startTimer();
      }
    } catch (err) {
      const error = err;

      toast.error(
        (props) => (
          <CustomToast {...props} type="error" message={error.errorMsg} />
        ),
        { icon: false }
      );
      return;
    }
  };

  return (
    <>
      <ToastContainer
        position="bottom-left"
        autoClose={3000}
        hideProgressBar
        closeOnClick
        pauseOnHover
        draggable
        closeButton={false}
        toastClassName={() => "toast-wrapper"}
        transition={Slide}
      />
      {!showOtpModal && (
        <div style={{ display: 'flex', height: '100vh', width: '100vw', boxSizing: 'border-box', fontFamily: "'Inter', sans-serif", backgroundColor: '#F8FAFC', position: 'relative', overflow: 'hidden', alignItems: 'center', justifyContent: 'center' }}>
          
          {/* Background Waves (Simulated with absolute blobs) */}
          <div style={{ position: 'absolute', top: '-10%', left: '-5%', width: '40%', height: '60%', background: '#E0F2FE', borderRadius: '50% 40% 60% 40%', transform: 'rotate(-15deg)', filter: 'blur(60px)', zIndex: 0, opacity: 0.6 }}></div>
          <div style={{ position: 'absolute', bottom: '-15%', right: '-10%', width: '50%', height: '70%', background: '#DBEAFE', borderRadius: '40% 60% 50% 50%', transform: 'rotate(20deg)', filter: 'blur(80px)', zIndex: 0, opacity: 0.5 }}></div>
          <div style={{ position: 'absolute', top: '10%', right: '15%', width: '30%', height: '40%', background: '#E0F2FE', borderRadius: '60% 40% 50% 50%', filter: 'blur(100px)', zIndex: 0, opacity: 0.7 }}></div>

          {/* MAIN CONTAINER */}
          <div style={{ display: 'flex', width: '100%', maxWidth: '1000px', alignItems: 'center', gap: '64px', position: 'relative', zIndex: 1, padding: '0 32px' }}>
            
            {/* LEFT SECTION */}
            <div style={{ flex: 1.2 }}>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '32px' }}>
                <img src={privuLogo} alt="Privu" style={{ height: '32px' }} />
                <div style={{ width: '1px', height: '32px', backgroundColor: '#CBD5E1' }}></div>
                <Text appearance="heading-xs" color="primary-blue-100" style={{ fontWeight: '600', fontSize: '14px', lineHeight: '1.2' }}>Consent<br/>Management</Text>
              </div>

              <div style={{ display: 'flex', gap: '12px', marginBottom: '24px' }}>
                <span style={{ backgroundColor: '#E0F2FE', color: '#0284C7', padding: '4px 12px', borderRadius: '100px', fontSize: '12px', fontWeight: '600' }}>Privacy</span>
                <span style={{ color: '#0284C7', padding: '4px 0', fontSize: '12px' }}>•</span>
                <span style={{ backgroundColor: '#E0F2FE', color: '#0284C7', padding: '4px 12px', borderRadius: '100px', fontSize: '12px', fontWeight: '600' }}>Compliance</span>
                <span style={{ color: '#0284C7', padding: '4px 0', fontSize: '12px' }}>•</span>
                <span style={{ backgroundColor: '#E0F2FE', color: '#0284C7', padding: '4px 12px', borderRadius: '100px', fontSize: '12px', fontWeight: '600' }}>Trust</span>
              </div>

              <h1 style={{ fontSize: '42px', fontWeight: '800', color: '#0F172A', lineHeight: '1.15', marginBottom: '16px', letterSpacing: '-0.5px' }}>
                Manage Consent<br/>with <span style={{ color: '#2563EB' }}>Confidence</span>
              </h1>
              
              <p style={{ fontSize: '14px', color: '#64748B', lineHeight: '1.6', marginBottom: '20px', maxWidth: '380px' }}>
                A secure and scalable consent management platform for your business and users.
              </p>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginBottom: '20px' }}>
                {/* Features */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <div style={{ width: '32px', height: '32px', backgroundColor: '#DCFCE7', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <BsShieldFillCheck size={16} color="#16A34A" />
                  </div>
                  <div>
                    <h3 style={{ fontSize: '14px', fontWeight: '700', color: '#0F172A', margin: 0 }}>Data Privacy Compliance</h3>
                    <p style={{ fontSize: '12px', color: '#64748B', margin: '2px 0 0 0' }}>Stay compliant with India's DPDPA</p>
                  </div>
                </div>
                
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <div style={{ width: '32px', height: '32px', backgroundColor: '#F3E8FF', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <BsGearFill size={16} color="#9333EA" />
                  </div>
                  <div>
                    <h3 style={{ fontSize: '14px', fontWeight: '700', color: '#0F172A', margin: 0 }}>Centralized Consent Management</h3>
                    <p style={{ fontSize: '12px', color: '#64748B', margin: '2px 0 0 0' }}>Manage user consent across all channels</p>
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <div style={{ width: '32px', height: '32px', backgroundColor: '#FFEDD5', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <BsBarChartFill size={16} color="#EA580C" />
                  </div>
                  <div>
                    <h3 style={{ fontSize: '14px', fontWeight: '700', color: '#0F172A', margin: 0 }}>Real-time Monitoring</h3>
                    <p style={{ fontSize: '12px', color: '#64748B', margin: '2px 0 0 0' }}>Track consent activities and system health</p>
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <div style={{ width: '32px', height: '32px', backgroundColor: '#DBEAFE', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <BsPeopleFill size={16} color="#2563EB" />
                  </div>
                  <div>
                    <h3 style={{ fontSize: '14px', fontWeight: '700', color: '#0F172A', margin: 0 }}>Enterprise Ready</h3>
                    <p style={{ fontSize: '12px', color: '#64748B', margin: '2px 0 0 0' }}>Built for security, scalability, and trust</p>
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ width: '18px', height: '18px', backgroundColor: '#2563EB', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <BsShieldLockFill size={10} color="white" />
                </div>
                <div>
                  <p style={{ fontSize: '11px', fontWeight: '600', color: '#475569', margin: 0 }}>Your Data. Their Choice. A Safer Tomorrow.</p>
                  <div style={{ width: '24px', height: '2px', backgroundColor: '#2563EB', marginTop: '4px' }}></div>
                </div>
              </div>
            </div>

            {/* RIGHT SECTION (Login Card) */}
            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', position: 'relative' }}>
               
               <div style={{ width: '100%', maxWidth: '400px', backgroundColor: 'white', borderRadius: '24px', padding: '40px', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.1), 0 0 20px 0 rgba(224, 242, 254, 0.5)', zIndex: 1, position: 'relative' }}>
                  

                  
                  <h2 style={{ fontSize: '22px', fontWeight: '800', color: '#0F172A', textAlign: 'center', margin: '0 0 8px 0' }}>Welcome Back</h2>
                  <p style={{ fontSize: '12px', color: '#64748B', textAlign: 'center', margin: '0 0 24px 0' }}>Sign in to access your consent management dashboard.</p>

                  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    
                    {/* Company ID / PAN */}
                    <div>
                      <label style={{ fontSize: '11px', fontWeight: '700', color: '#1E293B', marginBottom: '6px', display: 'block' }}>Company ID / PAN (Required)</label>
                      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                        <div style={{ position: 'absolute', left: '14px', color: '#64748B' }}>
                          <BsBuildingFill size={14} />
                        </div>
                        <div style={{ position: 'absolute', left: '38px', width: '1px', height: '16px', backgroundColor: '#E2E8F0' }}></div>
                        <input 
                          type="text"
                          placeholder="Enter your Company ID or PAN"
                          value={panNo}
                          onChange={handlePanChange}
                          style={{ width: '100%', padding: '12px 14px 12px 52px', fontSize: '12px', borderRadius: '8px', border: `1px solid ${isPanValid === false ? '#EF4444' : (panNo ? '#3B82F6' : '#E2E8F0')}`, outline: 'none', transition: 'all 0.2s', boxShadow: panNo ? '0 0 0 2px rgba(59, 130, 246, 0.1)' : 'none', boxSizing: 'border-box' }}
                        />
                      </div>
                    </div>

                    {/* Email / Mobile */}
                    <div>
                      <label style={{ fontSize: '11px', fontWeight: '700', color: '#1E293B', marginBottom: '6px', display: 'block' }}>Company Email (Required)</label>
                      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                        <div style={{ position: 'absolute', left: '14px', color: '#64748B' }}>
                          <BsEnvelopeFill size={14} />
                        </div>
                        <div style={{ position: 'absolute', left: '38px', width: '1px', height: '16px', backgroundColor: '#E2E8F0' }}></div>
                        <input 
                          type="text"
                          placeholder="Enter your company email"
                          value={emailMobile}
                          onChange={handleEmailMobileChange}
                          style={{ width: '100%', padding: '12px 14px 12px 52px', fontSize: '12px', borderRadius: '8px', border: `1px solid ${emailMobileValid === false ? '#EF4444' : (emailMobile ? '#3B82F6' : '#E2E8F0')}`, outline: 'none', transition: 'all 0.2s', boxShadow: emailMobile ? '0 0 0 2px rgba(59, 130, 246, 0.1)' : 'none', boxSizing: 'border-box' }}
                        />
                      </div>
                    </div>

                    {/* Options */}
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '2px' }}>
                       <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                         <input type="checkbox" style={{ width: '14px', height: '14px', accentColor: '#3B82F6', cursor: 'pointer', border: '1px solid #CBD5E1', borderRadius: '4px' }} />
                         <span style={{ fontSize: '11px', color: '#64748B' }}>Remember me</span>
                       </label>
                    </div>

                    {/* Submit Button */}
                    <button 
                      onClick={handleSubmit}
                      disabled={!isPanValid || !emailMobileValid}
                      style={{ 
                        width: '100%', 
                        padding: '12px', 
                        background: '#3B82F6', 
                        color: 'white', 
                        border: 'none', 
                        borderRadius: '8px', 
                        fontSize: '13px', 
                        fontWeight: '600', 
                        cursor: (!isPanValid || !emailMobileValid) ? 'not-allowed' : 'pointer', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        gap: '8px',
                        marginTop: '8px',
                        opacity: (!isPanValid || !emailMobileValid) ? 0.7 : 1,
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.25)',
                        transition: 'opacity 0.2s'
                      }}
                    >
                      Sign In <BsArrowRight />
                    </button>



                    <p style={{ textAlign: 'center', fontSize: '11px', color: '#64748B', margin: '8px 0 0 0' }}>
                      Don't have an account? <span onClick={() => navigate("/signup")} style={{ color: '#3B82F6', fontWeight: '600', cursor: 'pointer' }}>Create Account</span>
                    </p>
                  </div>
               </div>
            </div>
          </div>
        </div>
      )}

      {showOtpModal && !showTotpModal && (
        <div className="login-page">
          <div className="login-card">
            <div className="logoDiv">
              <div className="logoStyle">
                <img src={privuLogo} alt="Privu Logo" className="logoImg" />
              </div>
              <Text appearance="heading-xxs">Consent Management</Text>
            </div>
            <div className="otp-part">
              <div className="container-header-otp">
                <Text appearance="heading-xs">OTP verification</Text>
              </div>

              <div className="enter-otp">
                <Text appearance="body-xs" color="primary-grey-80">
                  Enter the 6-digit OTP sent to {emailMobile}
                </Text>
              </div>
              <br></br>

              <div ref={otpInputRef}>
                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginBottom: '8px' }}>
                  {[0, 1, 2, 3, 4, 5].map((index) => (
                    <input
                      key={index}
                      type="text"
                      inputMode="numeric"
                      maxLength={1}
                      value={otp[index] || ''}
                      disabled={(isOtpValid && !initalOtp) || disableAllFields}
                      autoFocus={index === 0}
                      style={{
                        width: '48px',
                        height: '48px',
                        textAlign: 'center',
                        fontSize: '20px',
                        fontWeight: '600',
                        border: `2px solid ${!initalOtp && !isOtpValid ? '#dc2626' : '#e5e7eb'}`,
                        borderRadius: '8px',
                        outline: 'none',
                        transition: 'border-color 0.2s',
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#0ea5e9'}
                      onBlur={(e) => e.target.style.borderColor = !initalOtp && !isOtpValid ? '#dc2626' : '#e5e7eb'}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        if (value) {
                          const newOtp = otp.split('');
                          newOtp[index] = value;
                          const updatedOtp = newOtp.join('');
                          setOtp(updatedOtp);
                          
                          // Auto-focus next input
                          if (index < 5 && value) {
                            const nextInput = e.target.parentElement?.children[index + 1];
                            if (nextInput) nextInput.focus();
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Backspace') {
                          if (otp[index]) {
                            // Clear current field
                            const newOtp = otp.split('');
                            newOtp[index] = '';
                            setOtp(newOtp.join(''));
                          } else if (index > 0) {
                            // If current field is empty, move to previous and clear it
                            const newOtp = otp.split('');
                            newOtp[index - 1] = '';
                            setOtp(newOtp.join(''));
                            const prevInput = e.target.parentElement?.children[index - 1];
                            if (prevInput) prevInput.focus();
                          }
                        }
                      }}
                      onPaste={(e) => {
                        e.preventDefault();
                        const pastedData = e.clipboardData.getData('text').replace(/[^0-9]/g, '').slice(0, 6);
                        setOtp(pastedData);
                        // Focus last filled input
                        const lastIndex = Math.min(pastedData.length - 1, 5);
                        const inputs = e.target.parentElement?.children;
                        if (inputs && inputs[lastIndex]) {
                          inputs[lastIndex].focus();
                        }
                      }}
                    />
                  ))}
                </div>
                {!initalOtp && !isOtpValid && (
                  <p style={{ color: '#dc2626', fontSize: '12px', textAlign: 'center', margin: '0' }}>
                    Please enter a valid OTP
                  </p>
                )}
              </div>
              <br></br>
              <p style={{ textAlign: "center", fontWeight: '600', marginTop: '8px' }}>
                <span
                  style={{ color: "#0ea5e9", cursor: "pointer" }}
                  onClick={() => {
                    setShowOtpModal(false);
                    setOtp("");
                    setIsOtpValid(false);
                    setInitialOtp(true);
                  }}
                >
                  Go back
                </span>
              </p>
              <p style={{ textAlign: "center", fontWeight: "600", marginTop: "8px" }}>
              <span
                onClick={
                  isResendDisabled || disableAllFields
                    ? undefined // ⛔ disables click completely
                    : handleResend // ✅ only works when enabled
                }
                style={{
                  color: "#0284c7",
                  cursor: isResendDisabled || disableAllFields ? "not-allowed" : "pointer",
                  opacity: isResendDisabled || disableAllFields ? 0.5 : 1,
                  // textDecoration: "none", // ❌ no underline by default
                }}
                className="resend-otp-link"
              >
                Resend OTP
              </span>
            </p>




              <div className="resend-otp-outer-div">
                {isResendDisabled && counter > 0 && (
                  <div>
                    <Text appearance="body-s-bold" color="primary-80">
                      {counter} Seconds
                    </Text>
                  </div>
                )}
              </div>
              <br></br>
              <div className="otp-button" style={{ width: '100%' }}>
                <ActionButton
                  label="Verify"
                  onClick={handleOtpSubmit}
                  stretch={true}
                  maxLength={6}
                  state={
                    isVerifyingOtp ? "loading" : (otp.length !== 6 || disableAllFields ? "disabled" : "normal")
                  }
                  tabIndex={2}
                  style={{ width: '100%' }}
                ></ActionButton>
              </div>
            </div>
          </div>
        </div>
      )}

      {showTotpModal && (
        <div className="login-page">
          <div className="login-card">
            <div className="logoDiv">
              <div className="logoStyle">
                <img src={privuLogo} alt="Privu Logo" className="logoImg" />
              </div>
              <Text appearance="heading-xxs">Consent Management</Text>
            </div>
            <div className="otp-part">
              <div className="container-header-otp">
                <Text appearance="heading-xs">Verify with Authenticator App</Text>
              </div>

              <div className="enter-otp">
                <Text appearance="body-xs" color="primary-grey-80">
                  Enter the 6-digit code from your Authenticator app
                </Text>
              </div>
              <br></br>

              <div ref={totpInputRef}>
                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginBottom: '8px' }}>
                  {[0, 1, 2, 3, 4, 5].map((index) => (
                    <input
                      key={index}
                      type="text"
                      inputMode="numeric"
                      maxLength={1}
                      value={totp[index] || ''}
                      disabled={(isTotpValid && !initialTotp) || disableAllFields}
                      autoFocus={index === 0}
                      style={{
                        width: '48px',
                        height: '48px',
                        textAlign: 'center',
                        fontSize: '20px',
                        fontWeight: '600',
                        border: '2px solid #e5e7eb',
                        borderRadius: '8px',
                        outline: 'none',
                        transition: 'border-color 0.2s',
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#0ea5e9'}
                      onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        if (value) {
                          const newTotp = totp.split('');
                          newTotp[index] = value;
                          const updatedTotp = newTotp.join('');
                          setTotp(updatedTotp);
                          
                          // Auto-focus next input
                          if (index < 5 && value) {
                            const nextInput = e.target.parentElement?.children[index + 1];
                            if (nextInput) nextInput.focus();
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Backspace') {
                          if (totp[index]) {
                            // Clear current field
                            const newTotp = totp.split('');
                            newTotp[index] = '';
                            setTotp(newTotp.join(''));
                          } else if (index > 0) {
                            // If current field is empty, move to previous and clear it
                            const newTotp = totp.split('');
                            newTotp[index - 1] = '';
                            setTotp(newTotp.join(''));
                            const prevInput = e.target.parentElement?.children[index - 1];
                            if (prevInput) prevInput.focus();
                          }
                        }
                      }}
                      onPaste={(e) => {
                        e.preventDefault();
                        const pastedData = e.clipboardData.getData('text').replace(/[^0-9]/g, '').slice(0, 6);
                        setTotp(pastedData);
                        // Focus last filled input
                        const lastIndex = Math.min(pastedData.length - 1, 5);
                        const inputs = e.target.parentElement?.children;
                        if (inputs && inputs[lastIndex]) {
                          inputs[lastIndex].focus();
                        }
                      }}
                    />
                  ))}
                </div>
              </div>
              <br></br>
              <p style={{ textAlign: "center", fontWeight: '600', marginTop: '8px' }}>
                <span
                  style={{ color: "#0ea5e9", cursor: "pointer" }}
                  onClick={() => {
                    setShowTotpModal(false);
                    setTotp("");
                    setIsTotpValid(false);
                    setInitialTotp(true);
                  }}
                >
                  Go back
                </span>
              </p>
              <br></br>
              <div className="otp-button" style={{ width: '100%' }}>
                <ActionButton
                  label="Verify"
                  onClick={handleTotpSubmit}
                  stretch={true}
                  maxLength={6}
                  state={
                    isVerifyingTotp ? "loading" : (totp.length !== 6 || disableAllFields ? "disabled" : "normal")
                  }
                  tabIndex={2}
                  style={{ width: '100%' }}
                ></ActionButton>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminLogin;
